var map = {
	"./1.webp": 1962,
	"./2.webp": 3851,
	"./3.webp": 6472,
	"./4.webp": 8385,
	"./desktop/1.webp": 4597,
	"./desktop/2.webp": 3848,
	"./desktop/3.webp": 3019,
	"./desktop/4.webp": 4662,
	"./desktop/5.webp": 9393,
	"./desktop/6.webp": 2052,
	"./desktop/7.webp": 3911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;